import { Box, Button, Grid, IconButton, Tooltip } from "@mui/material";
import DataTable from "../../../components/features/Datatable";
import { useDispatch, useSelector } from "react-redux";
import { deleteOnboardUser, disableAddModal, enableAddModal, fetchOnboardUser, selectBmrAddModal, selectBmrAllOnBoardUser } from "../../../slices/onBoardUser";
import { DeleteIconButton, EditIconButton, PermissionIconButton } from "../../../../assets/common-svg/CommonSvg";
import BsModal from "../../../components/common/BaseModal";
import AddNewUserForm from "./OnBoardForm/AddNewUser";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import DeleteModal from "../../../components/common/BaseModal/DeleteModal";
import ListDrawer from "../../../../components/ListDrawer/ListDrawer";
import Filter from "./OnBoardForm/Filter";
import { fetchAllRoles, selectAllRoles } from "../../../slices/roles";

const OnBoardUser = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const allRoles = useSelector(selectAllRoles)
    const [openDrawer, setOpenDrawer] = useState(false)
    const [phaseList, setPhaseList] = useState([])
    const [allFilters, setFilters] = useState(false);
    const allOnBoardUser = useSelector(selectBmrAllOnBoardUser)
    const addModal = useSelector(selectBmrAddModal)
    const [rowId, setRowId] = useState(null)
    const [open, setOpen] = useState(false)
    const updateFilter = (filter) => {
        setFilters(filter)
        fetchUsers(filter);
    }

    const filterConfig = {
        role_id: {
            label: "Role Type",
            enum: allRoles.reduce((acc, role) => {
                acc[role.id] = role.title;
                return acc;
            }, {})
        },
    }

    const getAllRoles = async () => {
        await dispatch(fetchAllRoles())
    }

    useEffect(() => {
        getAllRoles()
    }, [])

    const fetchUsers = async (filter) => {
        await dispatch(disableAddModal())
        await dispatch(fetchOnboardUser(filter))
    }

    const handleCloseModal = async () => {
        await dispatch(disableAddModal())
    }
    const handleAddModal = async () => {
        await dispatch(enableAddModal())
    }

    const handleDelete = async () => {
        await dispatch(deleteOnboardUser({ editId: rowId, filters: allFilters }))
        setOpen(false)
    }

    const columns = [
        {
            id: 'name',
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            id: 'email',
            name: 'Email',
            selector: row => row.email,
            sortable: true
        },
        {
            id: 'phone',
            name: 'Phone',
            selector: row => row.phone,
            sortable: true
        },
        {
            id: 'role',
            name: 'Role',
            selector: row => row.role_details.title,
            sortable: true
        },
        {
            id: 'hospital_name',
            name: 'Hospital Name',
           selector: row => (
        <div className="max-w-[200px] break-words whitespace-normal" title={row?.hospital_details?.name}>
            {row?.hospital_details?.name}
        </div>
        ),
        sortable: true
        },
        {
            id: 'phaseCount',
            name: 'Assigned Phases',
            selector: row => <span className="underline text-[blue] font-bold cursor-pointer" onClick={() => {
                setOpenDrawer(true)
                setPhaseList(row?.phase_user)
            }}>{row.phaseCount}</span>,
            sortable: true,
            align: 'center'
        },
        {
            name: 'Action',
            align: 'center',
            selector: row => <Box key={row.id}>
                <Tooltip title="View Permission" >
                    <span>
                        <IconButton onClick={() => navigate(`/bmr/on-board-user/permissions/${row.id}`,
                            {
                            state: [
                                { name: "OnBoard User", path: location.pathname },
                                {
                                name: row?.name +' ('+row?.role_details?.title+')',
                                path: `/bmr/on-board-user/permissions/${rowId}`,
                                },
                            ],
                            }
                        )}>
                            <PermissionIconButton
                                bgColor={"#3571FF"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Edit" >
                    <span>
                        <IconButton
                            onClick={() => { setRowId(row.id), handleAddModal() }}
                        >
                            <EditIconButton
                                bgColor={"#C3C3C3"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
                <Tooltip title="Delete" >
                    <span>
                        <IconButton
                            onClick={() => { setRowId(row.id), setOpen(true) }}
                        >
                            <DeleteIconButton
                                bgColor={"#FA5151"}
                            />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>
        },
    ];

    return (
        <Grid container className='m-4 ml-0 mainDiv' rowSpacing={4.5} columnSpacing={2.75}>
            <BsModal open={addModal} onClose={handleCloseModal} title={rowId ? "Edit User" : "Add New User"}>
                <AddNewUserForm editId={rowId} filters={allFilters} />
            </BsModal>
            <Grid item xs={12} sx={{ mt: -2.25 }}>
                <DataTable
                    columns={columns}
                    data={allOnBoardUser ?? []}
                    title="OnBoard User"
                    searchPlaceholder="Search by Name"
                    BtnComponent={<Button className="ml-2" onClick={() => (handleAddModal(), setRowId(null))}>Add New User</Button>}
                    // FilterComponent={DemoForm}
                    remote={true}
                    FilterComponent={Filter}
                    filterConfig={filterConfig}
                    onServerSideChange={updateFilter}
                />
            </Grid>
            <DeleteModal
                open={open}
                setClose={setOpen}
                title={"Are you sure you want to Delete ?"}
                buttonText={"Delete"}
                handleSuccess={handleDelete}
            />
            {openDrawer ?
                <ListDrawer
                    open={openDrawer}
                    toggleDrawer={() => setOpenDrawer(!openDrawer)}
                    listData={phaseList || []}
                    title="Phase List" />
                : null
            }
        </Grid>
    );
};

export default OnBoardUser;
